export default "__VITE_ASSET__e909197a__"